import fr from './fr.json'
import currency from './currency.json'

export const defaultLocale = 'fr'

export const languages = {
  fr: fr
}

export const currencies = currency
